export default "__VITE_ASSET__miM93cNU__"